import { MenuItemEnum } from './../../enums/menuItemEnum';
import { Component, OnInit } from '@angular/core';
import { SelectionOptionsPopUpService } from 'src/app/selection-options-pop-up.service';
import { AuthService } from 'src/app/services';

@Component({
	selector: 'app-selection-options-pop-up-button',
	templateUrl: './selection-options-pop-up-button.component.html',
	styleUrls: ['./selection-options-pop-up-button.component.scss'],
    standalone: false
})
export class SelectionOptionsPopUpButtonComponent implements OnInit {

	public visible: boolean;

	constructor(
		public selectionOptionsPopUpService: SelectionOptionsPopUpService,
		public authService: AuthService,
	) { }

	ngOnInit(): void {
		this.authService.getPermissions(
			{
				showLoadingIndicator: false,
			}
		).subscribe(
			{
				next: (rolePermissions) => {
					for (let a = 0; a < rolePermissions.length; a++) {
						const rolePermission = rolePermissions[a];

						if (rolePermission.menuId === MenuItemEnum.SelectionOptions) {
							this.visible = true;

							break;
						}
					}
				}
			}
		);
	}
}
